import type { GetFiatTransactionsParams } from '../types/fiatTransactionsTypes'

export const fiatTransactionKeys = {
  all: ['treasury', 'fiatTransactions'] as const,

  lists: () => [...fiatTransactionKeys.all, 'list'] as const,
  list: (filters: GetFiatTransactionsParams) => [...fiatTransactionKeys.lists(), filters] as const,

  details: () => [...fiatTransactionKeys.all, 'detail'] as const,
  detail: (id: string) => [...fiatTransactionKeys.details(), id] as const,
}
